import React, { useEffect, useState } from 'react'
import { Auth } from 'aws-amplify'
import { attachPolicy } from '../../../../../lib/pay-api-lib'
import { subscribe, publish } from '../../../../../lib/pubsubLib'
import { useSelector } from 'react-redux'
import { Button } from '../../../../../components'
import { getTableOrderList } from '../../../lib/onlpos-utils'
import { getPriceStr } from '../../../../../lib/utils'
import { getOrderItemInfoDpos } from '../../../../../lib-pos/transformOrders'
import {
  // onlposCreateOrderStatus,
  onlposCreateOrderStatus2,
  // onlposUpdateOrderStatus,
  onlposUpdateOrderStatus2,
} from '../../../lib/api-onlpos'
import { debug } from '../../../../../settings'

export default function SaleMain(props) {
  const {
    visibleOrderSection,
    visiblePaySection,
    selectedTableInfo,
    setSelectedTableInfo,
    orderList,
    updateOrderList,
    audioPlay,
  } = props
  const { shopInfo } = useSelector((state) => state.shop)

  useEffect(() => {
    if(debug) {
      // console.log('-'.repeat(50), 'Visible Mode')
      // console.log('visibleOrderSection', visibleOrderSection)
      // console.log('visiblePaySection', visiblePaySection)
    }
    if (!visibleOrderSection) setSelectedTableInfo(null)
  }, [visibleOrderSection, visiblePaySection])

  // useEffect(() => {
  //   console.log('selectedTableInfo?.tableCode', selectedTableInfo?.tableCode)
  // }, [selectedTableInfo])

  const [receivedOrderData, setReceivedOrderData] = useState(null)

  const [iotReady, setIotReady] = useState(false)
  const topicSub = `/${shopInfo.shopId}/order-to-onlpos`

  useEffect(() => {
    async function attchIotPolicy() {
      const cred = await Auth.currentCredentials()
      const identityId = cred.identityId

      // if (debug) {
      //   console.log('='.repeat(50), 'attach iot policy')
      //   console.log('identityId', identityId)
      // }

      let res = await attachPolicy({ identityId })
      if (res.err) {
        // if (debug) console.log('error attachPolicy', res.err.message)
        setIotReady(false)
      } else {
        // if (debug) console.log('attachPolicy', res.result)
        setIotReady(true)
      }
    }
    attchIotPolicy()
  }, [shopInfo])

  useEffect(() => {
    if (!iotReady) return
    let sub1 = subscribe({ topic: topicSub, messageHandler: handleSub })
    return () => sub1.unsubscribe()
  }, [iotReady])

  const handleSub = (msg) => {
    try {
      const d = msg.value
      setReceivedOrderData(d)
    } catch (e) {
      alert('ERROR at Notified Order', e.message)
    }
  }

  ///////////////////////////////////////////////////////////////////////////////
  // start handle smart order
  ///////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    if (receivedOrderData) updateOrder()
  }, [receivedOrderData])

  const updateOrder = async () => {
    try {
      const newOrderData = { ...receivedOrderData }

      //
      // 처리 전 주문 삭제
      //
      setReceivedOrderData(null)

      newOrderData.orderList.map((o) => {
        o.ct = Date.now()
        return null
      })

      const rTopic = topicSub + '/' + receivedOrderData.randId
      if (debug) {
        console.log('='.repeat(50), 'handleSub')
        console.log('rTopic                       ', rTopic)
        console.log('selectedTableInfo?.tableCode ', selectedTableInfo?.tableCode) 
        console.log('newOrderData.tableCode       ', newOrderData.tableCode)
        console.log('newOrderData                 ', newOrderData)
      }

      //
      // check_if_the_table_in_use
      //
      if (newOrderData.tableCode === selectedTableInfo?.tableCode) {
        const errMsg = newOrderData.tableCode + ' Table in Use'
        return publish({ topic: rTopic, message: { err: { message: errMsg } } })
      }

      //
      // @MenuPannel 참조
      //
      let orderForTable = null
      const tableOrders = orderList.filter(
        (o) => o.orderId === newOrderData.tableCode,
      )

      if (tableOrders.length > 0) orderForTable = tableOrders[0]

      let res = {}
      let params = {}

      //
      // 해당 테이블의 항목이 있는 경우
      //
      if (orderForTable) {
        // orderForTable = tableOrders[0]
        // console.log('orderForTable', orderForTable)

        const preOrderList = orderForTable.orderData?.orderList || []
        const newOrderList = [...preOrderList, ...newOrderData.orderList]

        if (debug) {
          console.log('-'.repeat(20), 'pre orderList')
          console.table(preOrderList)
          console.log('-'.repeat(20), 'new orderList')
          console.table(newOrderList)
        }

        const newOrderData2 = {
          ...newOrderData,
          orderList: newOrderList,
        }

        params = {
          shopInfo,
          tableCode: newOrderData.tableCode,
          body: {
            orderData: JSON.stringify(newOrderData2),
          },
        }
        res = await onlposUpdateOrderStatus2(params)
      }

      //
      // 해당 테이블의 항목이 없는 경우
      //
      else {
        params = {
          shopInfo,
          tableCode: newOrderData.tableCode,
          body: {
            orderData: JSON.stringify(newOrderData),
          },
        }

        res = await onlposCreateOrderStatus2(params)
      }

      if (res.err) throw Error(res.err.message)
      audioPlay()
      await updateOrderList()

      await publish({ topic: rTopic, message: { message: 'success' } })
    } catch (e) {
      alert(e.message)
    }
  }
  ///////////////////////////////////////////////////////////////////////////////
  // end - handle smart order
  ///////////////////////////////////////////////////////////////////////////////

  const styles = {
    wrap: {
      flex: 1,
      padding: '5px 10px',
      display: 'flex',
    },
    leftBlock: {
      flex: 1,
      // backgroundColor: '#ff5',
    },
    rightBlock: {},
  }

  return (
    <div style={styles.wrap}>
      <TableBlock {...props} style={styles.leftBlock} />
      <ButtonBlock {...props} style={styles.rightBlock} />
    </div>
  )
}

function TableBlock(props) {
  const { gStyle, colors, itemOptions } = props
  const tableList = itemOptions.tableList || []

  const styles = {
    wrap: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
    tableBox: {
      border: '1px solid ' + colors.dark,
      padding: 5,
      width: 160,
      height: 120,
    },
    tName: { ...gStyle.text, backgroundColor: colors.info },
  }

  return (
    <div style={{ ...props.style, ...styles.wrap }}>
      {tableList.map((t, i) => {
        return <TableBox key={i} tableInfo={t} {...props} />
      })}
    </div>
  )
}

function TableBox(props) {
  const {
    tableInfo,
    gStyle,
    colors,
    setVisibleOrderSection,
    setSelectedTableInfo,
    orderList,
  } = props

  const [tableOrderList, setTableOrderList] = useState([])
  useEffect(() => {
    const res = getTableOrderList({ orderList, tableInfo })
    setTableOrderList(res.tableOrderList)
  }, [orderList])

  const onClickTableBox = () => {
    setVisibleOrderSection(true)
    setSelectedTableInfo(tableInfo)
  }

  const styles = {
    tableBox: {
      border: '1px solid ' + colors.dark,
      padding: 5,
      width: 160,
      height: 120,
      overflow: 'hidden',
      // overflow: 'scroll'
    },
    tName: { ...gStyle.text, backgroundColor: colors.info },
    orderInfo: { padding: '3px 0px' },
  }
  return (
    <div style={styles.tableBox} onClick={onClickTableBox}>
      <p
        style={styles.tName}
      >{`${tableInfo.tableName} (${tableInfo.tableCode})`}</p>
      <div style={styles.orderInfo}>
        {tableOrderList.map((o, i) => {
          if (i < 4) {
            return <OrderInfo key={i} {...props} orderInfo={o} />
          } else if (i === 4) {
            return (
              <p
                key={i}
                style={{ ...gStyle.text, fontSize: '0.7rem', fontWeight: 600 }}
              >
                ... more
              </p>
            )
          } else {
            return null
          }
        })}
      </div>
    </div>
  )
}

function OrderInfo(props) {
  const { orderInfo, gStyle } = props

  const [itemTxt, setItemTxt] = useState('')
  const [amt, setAmt] = useState(0)

  useEffect(() => {
    const { itemAmt, itemTxt, optTxt } = getOrderItemInfoDpos({
      order: orderInfo,
    })
    // console.log(itemAmt, itemTxt, optTxt)
    const itemStr = optTxt ? `${itemTxt} (${optTxt})` : itemTxt
    setItemTxt(itemStr)
    setAmt(itemAmt)
  }, [orderInfo])

  const styles = {
    orderWrap: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    txt: { ...gStyle.text, fontSize: '0.7rem' },
  }
  return (
    <div>
      <div style={styles.orderWrap}>
        <p style={styles.txt}>{itemTxt}</p>
        <p style={styles.txt}>{getPriceStr(amt)}</p>
      </div>
    </div>
  )
}

function ButtonBlock(props) {
  const btns = [
    { name: 'moveTable', displayName: '자리이동' },
    { name: 'moveTableCancel', displayName: '이동취소' },
    { name: 'tableCombine', displayName: '자리묶음' },
    { name: 'combineCancel', displayName: '묶음취소' },
    { name: 'tableSplit', displayName: '자리분할' },
    { name: 'payManage', displayName: '결제관리' },
    { name: 'saleManage', displayName: '매출관리' },
    { name: 'viewOutput', displayName: '직전출력' },
    { name: 'moveMenu', displayName: '메뉴이동' },
    { name: 'payment', displayName: '결제처리' },
    { name: 'payCard', displayName: '카드결제' },
    { name: 'close', displayName: '닫기' },
  ]

  const onClick = (obj) => alert(obj.displayName)

  return (
    <div style={props.style}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: '110px',
          // height: 650,
          padding: '0px 3px 0px 6px',
          // backgroundColor: 'red',
        }}
      >
        {btns.map((b, i) => {
          return (
            <Button
              key={i}
              title={b.displayName}
              onClick={() => onClick(b)}
              variant="outline-secondary"
              size="sm"
              width="100%"
              style={{ height: 40, marginBottom: 3 }}
            />
          )
        })}
      </div>
    </div>
  )
}
